import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { ThemeContext } from '../../constants/themes';
import Type from '../../components/atoms/Type';
import Button from '../../components/atoms/Button';
import Loader from '../../components/atoms/Loader';
import Navbar from '../../components/molecules/Navbar';
import Authenticator from '../../components/molecules/Authenticator';
import TextSubmit from '../../components/molecules/TextSubmit';
import { useAuth0 } from "@auth0/auth0-react";
import './index.css';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}
  
const Login = (props) => {
  const { loginWithRedirect } = useAuth0();

  const query = useQuery();
  
  useEffect(() => {
    // signup or signin
    const defaultView = query.get("defaultView");
    const authType = query.get("authType");
    const redirectUri = query.get("redirectUri");
    loginWithRedirect({
      screen_hint: defaultView,
      authType,
      redirectUri: `${window.location.origin}/${redirectUri}`
    });
  }, [])

  return (
    <ThemeContext.Consumer>
      {themeContext => (
        <div className="loading-background" style={{backgroundColor: themeContext.theme.body}}>
          <Loader />
        </div>
      )}
    </ThemeContext.Consumer>
  );
}
  
export default Login;
  